import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../support/with_presenter';
import {TrainingPlanSearchModalPresenter} from './TrainingPlanSearchModalPresenter';
import Modal from '../../../../components/modal';
import {If} from '../../../../components/if';
import {TrainingPlan} from '../../models/TrainingPlan';

interface OwnProps {
    visible: boolean;
    onDismiss: () => void;
    onSubmit: (trainingPlans: TrainingPlan[]) => void;
}

const TrainingPlanSearchModalComponent: FunctionComponent<OwnProps & PresenterProps<TrainingPlanSearchModalPresenter>> =
    observer(({presenter, visible}) => {
        return (
            <Modal visible={visible} onHide={() => presenter.onDismiss()}>
                <div className="modal-header">
                    <h2>Search your training plans</h2>
                </div>
                <div className="modal-body">
                    <If condition={presenter.loading}>
                        <div>Loading...</div>
                    </If>
                    <If condition={!presenter.loading}>
                        <div className="training-plan-element-selector__search-list">
                            {presenter.trainingPlans.map((trainingPlan) => (
                                <button
                                    key={trainingPlan.id}
                                    className="training-plan-element-selector__search-list-item"
                                    disabled={!trainingPlan.is_published}
                                    onClick={() =>
                                        trainingPlan.is_published && presenter.onTrainingPlanClick(trainingPlan)
                                    }
                                >
                                    {trainingPlan.title} {!trainingPlan.is_published && '(not published)'}
                                    {trainingPlan.is_published ? (
                                        presenter.isSelected(trainingPlan) ? (
                                            <div className="ion-md-checkmark-circle pull-right" />
                                        ) : (
                                            <div className="ion-md-checkmark-circle-outline pull-right" />
                                        )
                                    ) : null}
                                </button>
                            ))}
                        </div>
                    </If>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-primary pull-right" onClick={() => presenter.onAddClick()}>
                        Add
                    </button>
                    <button className="btn btn-secondary pull-right" onClick={() => presenter.onDismiss()}>
                        Cancel
                    </button>
                </div>
            </Modal>
        );
    });

export const TrainingPlanSearchModal = withPresenter<TrainingPlanSearchModalPresenter, OwnProps>(
    (props, component) =>
        new TrainingPlanSearchModalPresenter(props.onSubmit, props.onDismiss, component.trainingPlanProvider),
    TrainingPlanSearchModalComponent,
);
